import { useState, createContext, useEffect } from 'react';

const AuthContext = createContext();

// Current user context provider
const AuthContextProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [accUsername, setAccUsername] = useState(null); 
    const [userId, setUserId] = useState(null);
    const [wishlist, setWishlist] = useState([]);
    const [cartList, setCartList] = useState([]);
    const [loading, setLoading] = useState(true);

    // Check localStorage on component mount
    useEffect(() => {
        const storedAuth = localStorage.getItem('isAuthenticated');
        const storedUsername = localStorage.getItem('username');
        const storedUserId = localStorage.getItem('userId');
        
        if (storedAuth === 'true' && storedUsername && storedUserId) {
            setIsAuthenticated(true);
            setAccUsername(storedUsername);
            setUserId(storedUserId);
        }
        setLoading(false);
    }, []);

    // Add a logout function
    const logout = () => {
        localStorage.removeItem('isAuthenticated');
        localStorage.removeItem('username');
        localStorage.removeItem('userId');
        setIsAuthenticated(false);
        setAccUsername(null);
        setUserId(null);
    };

    // 持久化 setIsAuthenticated
    const setIsAuthenticatedPersist = (val) => {
        setIsAuthenticated(val);
        localStorage.setItem('isAuthenticated', val ? 'true' : 'false');
    };
    // 持久化 setAccUsername
    const setAccUsernamePersist = (val) => {
        setAccUsername(val);
        if (val) localStorage.setItem('username', val);
        else localStorage.removeItem('username');
    };
    // 持久化 setUserId
    const setUserIdPersist = (val) => {
        setUserId(val);
        if (val) localStorage.setItem('userId', val);
        else localStorage.removeItem('userId');
    };

const addToWishlist = (prodId) => {
    setWishlist((prevWishlist) => [...prevWishlist, { prod_id: prodId }]);
};

const removeFromWishlist = (prodId) => {
    setWishlist((prevWishlist) => prevWishlist.filter(item => item.prod_id !== prodId));
};

const addToCartList = (prodId) => {
    setCartList((prevCartList) => [...prevCartList, {prod_id: prodId}]);
}

const removeFromCartList = (prodId) => {
    setCartList((prevCartList) => prevCartList.filter((item) => item.prod_id !== prodId));
} 


    return (
        <AuthContext.Provider value={{ 
            isAuthenticated, 
            setIsAuthenticated: setIsAuthenticatedPersist, 
            accUsername, 
            setAccUsername: setAccUsernamePersist, 
            userId, 
            setUserId: setUserIdPersist, 
            logout,
            wishlist, 
            setWishlist, 
            addToWishlist, 
            removeFromWishlist, 
            cartList, 
            setCartList, 
            addToCartList, 
            removeFromCartList,
            loading
        }}>
            {children}
        </AuthContext.Provider>
    );
};

export { AuthContext, AuthContextProvider };
